import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import CustomButton from "components/CustomButton";
import { FormSelects, FormInputs } from "components/FormInputSelect";
import { TOOLBAR_SELECT_STYLES } from "components/toolbarSelectStyles";
import { Bell, Sort, ChevronUp, ChevronDown } from "assets";
import { BiFilter } from "react-icons/bi";
import { FiSearch } from "react-icons/fi";
import Table from "components/Table";
import { API_GET_MAMBOO } from "services";
import Pagination from "components/Pagination";
import { useNavigate } from "react-router-dom";
import ModalImport from "components/ModalImport";
import useLoginStore from "hooks/useLoginStore";

const Distribusi = () => {
  const {isVerified} = useLoginStore();
  const [isShow, setIsShow] = useState({
    label: "5",
    value: 5,
  });
  const [isPage, setIsPage] = useState(1);
  const [isTotalPage, setIsTotalPage] = useState();
  const [dataTable, setDataTable] = useState([])
  const navigate = useNavigate();

  const title = ["Detail Songwriter", "Share Performing", "Nilai Performing", "Share Mechanical", "Nilai Mechanical", "Share Synchron", "Nilai Synchron", "Share Demd", "Nilai Demd"]
  const titleValue = ["creator_name", "perform", "nilai_perform", "mech", "nilai_mech", "sync", "nilai_sync", "demd", "nilai_demd"]

  const formatDate = (cell) => {
    const startDate = new Date(cell.split(" - ")[0]);
    const endDate = new Date(cell.split(" - ")[1]);

    const options = { year: "2-digit", month: "short", day: "2-digit" };
    const startFormatted = startDate.toLocaleDateString("id-ID", options).replace(",", "");
    const endFormatted = endDate.toLocaleDateString("id-ID", options).replace(",", "");

    return startFormatted + " - " + endFormatted;
  }

  const getDetail = async (id) => {
    await API_GET_MAMBOO.dynamic.getDetailTransaksi(id)
      .then((res) => {
        navigate('/transaksi/detail', { state: { detailTransaksi: [{ ...res[0] }] } })
      })
  }

  const formatCurrency = new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  });

  const columnRefs = [
    {
      dataField: "song_title",
      text: (
        <>
          <span>Judul Lagu</span>
          <Sort />
        </>
      ),
      sort: true,
    },
    {
      dataField: "client",
      text: (
        <>
          <span>Client</span>
          <Sort />
        </>
      ),
      sort: true
    },
    {
      dataField: "periode",
      text: (
        <>
          <span>Periode Pemakaian</span>
          <Sort />
        </>
      ),
      sort: true,
      // formatter: (cell, row) => formatDate(cell)
    },
    {
      dataField: "total_transaction",
      text: (
        <>
        <span>Nilai Royalti</span>
        <Sort />
        </>
      ),
      formatter: (cell, row) => formatCurrency.format(cell),
    },
  ];

  const expandComponent = {
    renderer: row => (
      <div className='expand-container'>
        {row.expand && Object.keys(row.expand).map((item, i) => (
          <div className='expand-content'>
            <span className="expand-title" style={{ textTransform: 'capitalize', fontSize: "16px" }}>{title[i]}</span>
            <div className='expand-data'>
              {item !== "info" && item !== "period" && item !== "product" ?
                row.expand[titleValue[i]].map((val, i) => (
                  <>
                  <span className='expand-text'>{typeof val === "number" ? formatCurrency.format(val) : val}</span>
                  </>
                ))
                : 
                <span className='expand-text'>{row.expand[item]}</span>
                }
              {i === (Object.keys(row.expand).length - 1) &&
                <CustomButton
                  label="Detail Laporan"
                  size="btn-sm"
                  className="btn-full button-import mt-5 align-self-center ms-4"
                  onClick={() => getDetail(row.transaction_id)}
                />
              }
            </div>
          </div>
        ))
        }
      </div >
    ),
    onlyOneExpanding: true,
    parentClassName: (isExpanded, row, rowIndex) => {
      return 'parent-expand'
    },
    className: (isExpanded, row, rowIndex) => {
      return 'row-expand'
    },
    expandByColumnOnly: true,
    showExpandColumn: true,
    expandColumnPosition: 'right',
    expandHeaderColumnRenderer: () => "Detail",
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return (
          <ChevronUp />
        )
      } else {
        return (
          <ChevronDown />
        )
      }
    }
  }

  const options = [
    {
      label: "5",
      value: 5,
    },
    {
      label: "10",
      value: 10,
    },
    {
      label: "25",
      value: 25,
    },
    {
      label: "50",
      value: 50,
    },
  ];

  const onChangeSelect = (e) => {
    setIsShow(e.value);
  };

    const handleClickNumber = (page) => {
    API_GET_MAMBOO.dynamic
    .getDistributionDashboard(page, isShow.value)
    .then((response) => {
      let isData = response.data.map((val) => {
        let expand = {}
        val.expand.forEach((x) => {
          for (let key in x) {
            if(expand[key]) {
              expand[key] = [...expand[key], x[key]]
            } else {
              expand[key] = [x[key]]
            }
          }
        })
        return {
          ...val, expand
        }
      })
      isData.forEach((val, i) => val.id = i + 1)
      let totalPage = Math.ceil(response.total / isShow.value)
      setIsTotalPage(totalPage)
      setDataTable(isData);
      setIsPage(page);
    })
    .catch((err) => {
      setDataTable([]);
    });
  }

  const modalContentVerified = () => {
    return (
      <div className="custom-modal-body">
        <span style={{fontSize: 'large', fontWeight: 'bold', textAlign: 'center'}}>Segera Verifikasi Publisher</span>
          <span style={{fontSize: 'small', fontSize: '15px'}}>Buka semua fitur yang ada dengan cara melengkapi dokumen yang ada dan nantinya akan kami verifikasi terlebih dahulu.</span>
      </div>
    )
  }

  useEffect(() => {
    API_GET_MAMBOO.dynamic
      .getDistributionDashboard(isPage, isShow.value)
      .then((response) => {
        let isData = response.data.map((val) => {
          let expand = {}
          val.expand.forEach((x) => {
            for (let key in x) {
              if(expand[key]) {
                expand[key] = [...expand[key], x[key]]
              } else {
                expand[key] = [x[key]]
              }
            }
          })
          return {
            ...val, expand
          }
        })
        isData.forEach((val, i) => val.id = i + 1)
        let totalPage = Math.ceil(response.total / isShow.value)
        setIsTotalPage(totalPage)
        setDataTable(isData);
      })
      .catch((err) => {
        setDataTable([]);
      });
  }, [isShow]);
  return (
    <>
      <Container fluid className="content-pencipta">
        <div className="header-content">
          <div className="pencipta-header">
            <h1>Laporan Distribusi</h1>
            <span>Deskripsi</span>
          </div>
          <div className="icon-wrapper">
            <Bell />
          </div>
        </div>
        <div className="tabs-filters">
          <div className="frame-filters">
            <div className="frame-sub-filters">
              <div className="frame-cari-nama">
                <div className="box-text-cari-nama">
                  <span className="text-cari-nama">Cari Judul</span>
                </div>
                <FormInputs
                  placeholder="Masukkan Judul Lagu"
                  className="frame-cari-nama"
                />
                <div className="frame-search">
                    <FiSearch />
                  </div>
              </div>
            </div>
            <CustomButton
              label="Filter"
              LabelIcon={BiFilter}
              iconPosition="left"
              size="md"
              className="button-filter"
            />
          </div>
        </div>
        <Table columnRefs={columnRefs} dataTable={dataTable} expandRow={expandComponent} noDataText="Belum ada Laporan" />
        {/* Satu baris kaki tabel: pemilih jumlah baris di kiri, lalu
            keterangan halaman dan navigasinya. Ketiganya mengatur paginasi,
            jadi dikumpulkan dalam satu baris. Garis atas dan padding kiri
            dipindah ke pembungkus ini (lihat .table-footer di pencipta.scss)
            supaya garisnya membentang penuh, bukan mulai setelah "Show". */}
        <div className="table-footer">
          <div className="table-footer-filters">
            <p className="text-show">Show :</p>
            <FormSelects
              options={options}
              onChange={onChangeSelect}
              defaultValue={isShow}
              value={isShow}
              styles={TOOLBAR_SELECT_STYLES}
            />
          </div>
          <Pagination isTotalPage={isTotalPage} isPage={isPage} handleClickNumber={handleClickNumber} 
            pageToShow={6}
          />
        </div>
      </Container>
      <ModalImport
        modal={!isVerified}
        title=""
        body={modalContentVerified()}
        centered={true}
        buttonLabel={"Go to Profile"}
        onClick={() => navigate("/profile")}
      />
    </>
  );
};

export default Distribusi;
